export const enum UTF8_STATUS {
	ACCEPT = 0,
	REJECT = 1,
}

export interface StringBufAggsUtf8 {
	allAscii: boolean;
	utf8State: number;
	validUtf8: boolean;
	length: number;
	numInvalidUtf8Seqs: number;
	numValidUtf8Seqs: number;
}

export interface StrBufNullAggs {
	numNulls: number;
	nulls: [number, number, number, number];
}

export interface StringBufAggsBasic extends StringBufAggsUtf8, StrBufNullAggs {}

export interface StringBufAggsHisto extends StringBufAggsBasic {
	histo: number[];
}
